var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { supportContactInformation } from '@/constants/support.constant';
import { useStyledModal } from '@/hooks/use-styled-modal.hook';
import { ButtonBase, Link, Typography } from '@mui/material';
import { useAnalytics } from 'hx-analytics';
function DisclaimerPopup() {
    return (_jsxs("div", __assign({ className: "flex flex-col items-center gap-16 md:min-h-52" }, { children: [_jsxs("div", __assign({ className: "flex flex-col gap-10 text-center" }, { children: [_jsx(Typography, __assign({ variant: "h2", className: "md:text-4xl text-3xl" }, { children: "Please note" })), _jsx(Typography, __assign({ className: "text-lg text-center font-medium md:text-2xl text-balance" }, { children: "If you continue the test without headphones, you will still get results, but they may not be as accurate as if you use headphones." }))] })), _jsx(Link, __assign({ href: supportContactInformation.phone.href, className: "text-lg no-underline mx-auto w-fit md:hidden text-eargo-blice-blue", target: "_blank" }, { children: "Need help?" }))] })));
}
export function HeadphonesTip() {
    var _a = useStyledModal(_jsx(DisclaimerPopup, {})), modal = _a[0], toggleModal = _a[1];
    var sendButtonClick = useAnalytics().sendButtonClick;
    function onClick() {
        toggleModal();
        sendButtonClick('tip_disclaimer');
    }
    return (_jsxs(_Fragment, { children: [modal, _jsx(ButtonBase, __assign({ onClick: onClick, className: "w-fit mx-auto" }, { children: _jsx(Typography, __assign({ className: "text-primary text-lg hover:underline" }, { children: "Disclaimer" })) }))] }));
}
